import { inject, Injectable } from '@angular/core';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { forkJoin, Observable, tap } from 'rxjs';
import { UserProfile } from '../../models/user-profile';
import { environment } from '../../../environments/environment';

const GRAPH_ENDPOINT = 'https://graph.microsoft.com/v1.0';

const LOCAL_PROFILE: UserProfile = {
  id: 'local-dev-user',
  displayName: 'Local Dev',
  givenName: 'Local',
  surname: 'Dev',
  mail: 'local.dev@example.com',
};

@Injectable({ providedIn: 'root' })
export class UserProfileService {
  profile: UserProfile = {};
  authenticated = false;

  private readonly http = inject(HttpClient);

  constructor() {
    this.getProfile();
  }

  getProfile(): void {
    if (environment.auth.disabled) {
      this.profile = { ...LOCAL_PROFILE };
      this.authenticated = true;
      return;
    }

    forkJoin({
      account: this.getAdProfile(),
      photo: this.getAdUserPhoto(),
    }).subscribe(({ account, photo }) => {
      this.profile = account;
      this.createImageFromBlob(photo);
    });
  }

  getAdProfile(): Observable<UserProfile> {
    return this.http.get<UserProfile>(`${GRAPH_ENDPOINT}/me`);
  }

  getAdUserPhoto(): Observable<Blob> {
    const url = `${GRAPH_ENDPOINT}/me/photos/48x48/$value`;
    return this.http
      .get(url, {
        headers: new HttpHeaders({ 'Content-Type': 'image/jpg' }),
        responseType: 'blob',
      })
      .pipe(tap({ error: (error) => console.error(error) }));
  }

  private createImageFromBlob(image: Blob): void {
    const reader = new FileReader();
    reader.addEventListener(
      'load',
      () => {
        if (typeof reader.result === 'string') {
          this.profile.avatar = reader.result;
        }
      },
      false,
    );

    if (image) {
      reader.readAsDataURL(image);
    }
  }
}
